module.exports = __webpack_public_path__ + "img/PXL_20230525_091718605.926f9991.jpg";